import CombinedCard from "./CombinedCard";

export default function BuyItemsGrid({ items, onOpen, getColClass }) {
  return (
    <div className="buy-and-supply__items-holder__items row m-0">
      {items.map((item, index) => (
        <div key={item.itemId} className={getColClass(index)}>
          <CombinedCard data={item} onOpen={onOpen} />
        </div>
      ))}
    </div>
  );
}
